let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hhvXj")).then(() => parcelRequire('bJ8Yy'));